var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ImageBubble } from '../elements/image-bubble';
import { useEntity } from '../hooks/use-entity';
import { IconLink } from '../elements/icon-link';
import { DottedChevronRightHeavyIconGlyph } from '@shapeable/icons';
var cls = classNames('block-bubble');
export var BlockBubbleDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    a {\n      text-decoration: none;\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    a {\n      text-decoration: none;\n    }\n  "])))
});
var BubbleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: 1px solid ", ";\n  "], ["\n    border: 1px solid ", ";\n  "])), theme.COLOR('line-subtle'))
});
var TitlesStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    min-height: 3em;\n    \n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    min-height: 3em;\n    \n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1em;\n    margin: ", " 0 0;\n    text-align: center;\n    color ", ";\n  "], ["\n    font-size: 1em;\n    margin: ", " 0 0;\n    text-align: center;\n    color ", ";\n  "])), theme.UNIT(2), theme.COLOR('strong'))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: ", " 0 0;\n    font-size: 1em;\n    font-weight: 300;\n    text-align: center;\n    color ", ";\n  "], ["\n    margin: ", " 0 0;\n    font-size: 1em;\n    font-weight: 300;\n    text-align: center;\n    color ", ";\n  "])), theme.UNIT(1), theme.COLOR('sub'))
});
var LinkStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 0.8em;\n    margin-top: ", ";\n    color ", ";\n  "], ["\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 0.8em;\n    margin-top: ", ";\n    color ", ";\n  "])), theme.UNIT(3), theme.COLOR('strong'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Bubble: styled(ImageBubble)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles),
  Titles: styled.div.attrs(cls.attr('titles'))(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  Title: styled.h2.attrs(cls.attr('title'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled.h3.attrs(cls.attr('subtitle'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Link: styled(IconLink)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var BlockBubble = function (props) {
  var className = props.className,
    children = props.children,
    linkSubject = props.linkSubject;
  var entity = useEntity(props.entity);
  var image = entity.image,
    title = entity.title,
    subtitle = entity.subtitle,
    link = entity.link;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, image && image.image && React.createElement(My.Bubble, {
    size: 150,
    image: image.image
  }), React.createElement(My.Titles, null, title && React.createElement(My.Title, null, title), subtitle && React.createElement(My.Subtitle, null, subtitle)), link && link.url && React.createElement(My.Link, {
    reverse: true,
    iconSize: 18,
    icon: React.createElement(DottedChevronRightHeavyIconGlyph, null),
    href: "".concat(link.url).concat(linkSubject ? "?subject=".concat(linkSubject) : '')
  }, link.label || link.name), children);
};
BlockBubble.defaultProps = BlockBubbleDefaultProps;
BlockBubble.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;